module.exports = __webpack_public_path__ + "static/media/img9.7c8357f9.jpg";